<template>
  <div class="cargolist">
    <m-title :titlelist="listitem"></m-title>
    <div class="southcargonn">
      <div class="bigbox">
        <div class="southcargo_top">
          <!-- <columnper :itemper="jihua" :amount="alldun"></columnper> -->
          <div class="steer"><span style="font-weight: bold;">充电站名称：</span>{{ datamsg.locationName }}</div>
          <div class="southcargo_top_content">
            <ul>
              <li>充电桩个数：{{ datamsg.stationCount }}个</li>
              <li>充电次数：{{ datamsg.chargeCount }}次</li>
              
            </ul>
            <ul>
              <!-- <li>负责人：{{ datamsg.principal }}</li> -->
              <li>充电口个数：{{ datamsg.stationCount*2 }}个</li>
              <li>充电电量：{{ datamsg.chargeEnergy }}度</li>
              
            </ul>
            <ul>
              <!-- <li>负责人联系方式：{{ datamsg.principalTel }}</li> -->
              <li>负责人：{{ datamsg.principal }}</li>
              <li>充电金额：{{ datamsg.chargeElecMoney }}元</li>
            </ul>

            <ul>
              <li>当前空闲桩数：{{ datamsg.idleStationCount }}个</li>
              <li>充电服务金额：{{ datamsg.chargeServiceMoney }}元</li>
            </ul>
            <ul>
              <li>充电站位置:{{ datamsg.locationName }}</li>
              <li>充电总金额：{{ datamsg.chargeMoney }}元</li>
            </ul>
          </div>
        </div>
        <div class="southcargo_bot">
          <div class="list_title">
            <div class="title-left">
              <span style="margin: 0 10px 0 20px">充电桩名称</span>
              <input type="text" style="height: 30px;" placeholder="请输入" v-model="selectitem.name"/>
              <span style="margin: 0 10px 0 20px">充电桩状态</span>
              <div class="select_box1">
                <m-select :list="selectastrict" :value="astrictval"  @input="chanval" style="height:30px"></m-select>
              </div>
            </div>
            <div class="title-right">
              <button class="button1" @click="goback">返回</button>
              <button @click="getsearch">查询</button>
              <button class="button1" @click="clearsearch">重置</button>
              <button  @click="printList">导出</button>
            </div>
          </div>
          <!-- <div class="southcargo_bot_title"></div> -->
          <div class="tablebox">
            <el-table
              height="95%"
              :data="tablelist.list"
              style="width: 100%;"
              border
            >
              <el-table-column
                label="序号"
                type="index"
                width="50px"
              ></el-table-column>
              <el-table-column prop="deviceNo" label="充电桩编号" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="name" label="充电桩名称" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="status" label="充电桩状态" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column  label="充电口个数" show-overflow-tooltip :render-header="renderHeader">
                <template>
                  <div>
                    1
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="chargeCount" label="充电次数" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeTime" label="充电时长（分钟）" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeEnergy" label="充电量（度）" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeElecMoney" label="充电金额（元）" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeServiceMoney" label="充电服务金额（元）" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeMoney" label="充电总金额（元）" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="locationName" label="所属充电站" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="suttle" label="操作" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="row">
                  <span
                    @click="jumpParticulars(row, (limit = 1), (page = 1))"
                    style="color: #13D168;cursor: pointer;"
                    >查看详情</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="paging">
              <el-pagination
                :page-size="selectitem.limit"
                layout="total,prev, pager,next, jumper"
                :total="tablelist.total"
                :current-page="tablelist.pages"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle';
import mChebox from '@/components/mChebox.vue';
import columnper from '@/components/columnper';
import mSelect from '@/components/mSelect.vue';
import { printExcel } from '@/plugins/other.js';
export default {
  name: 'cargoinfo',
  data() {
    return {
      listitem: [{name:'计划列表'}],
      datamsg: {},
      checked: 0,
      jihua: 0,
      alldun: 1,
      pno: '',
      selectitem: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        params: null,
        status: null,
        name: '',
        locationName:""
      },
      tablelist: {},
      tabledata: [],
      timeout: null,
      checked: false,
      astrictval: '全部',
      selectastrict: ['全部', '空闲中', '充电中'], //作业节点
      value1: '',
      value2: '',
      station:sessionStorage.getItem('station')||""
    };
  },
  components: {
    mTitle,
    columnper,
    mChebox,
    mSelect,
  },
  created() {
    if(this.$route.query.name){
      this.selectitem.name=this.$route.query.name
      this.station=this.$route.query.stationname
    }
    this.getinfomsg();
  },
  methods: {
    // 查询
    getsearch() {
      this.gettablelist();
    },
    clearsearch(){
      this.selectitem.name=""
      this.selectitem.status=null
      this.gettablelist();
    },
    chanval(e) {
      this.astrictval = e;
      switch (e) {
        case '全部':
          this.$set(this.selectitem, 'status', null);
          break;
        case '空闲中':
          this.$set(this.selectitem, 'status', 1);
          break;
        case '充电中':
          this.$set(this.selectitem, 'status', 2);
          break;
      }
    },
    // 跳转
    jumpParticulars(row, limit, page) {
      let params={name: row.row.name, limit: limit, page: page}
      sessionStorage.setItem("params",JSON.stringify(params))
      this.$router.push({
        name: 'chargingpile',
        params: { name: row.row.name, limit: limit, page: page },
      });
    },
    //通过时间戳转换具体时间
    getSimpleDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s;
    },
    // 详情列表
    async getinfomsg() {
      const { data } = await this.$http(
        'api1',
        '/api/replenish/station/stationDatail',
        'get',
        { station: this.station }
      );
      if (data.code != 0) return console.log('获取详情数据失败');
      this.datamsg = data.data;
      this.jihua = data.data.sumSullte  || 0;
      this.alldun = data.data.plantons  || 1;
      this.gettablelist();
    },
    // 表格数据的获取
    async gettablelist() {
      this.selectitem.params = this.datamsg.params || null;
      this.selectitem.locationName=this.station
      const { data } = await this.$http(
        'api1',
        '/api/replenish/log/pileDatail',
        'get',
        this.selectitem
      );
      if (data.code != 0) return console.log('获取表格数据失败');
      this.tablelist = data.data;
    },
    exportlist() {
      if (!this.datamsg.pno) return '';
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async (_) => {
        const { data } = await this.$http(
          'api1',
          '/driver/dispatchtruck/exportPlanDispatchTruckList',
          'get',
          { pno: this.datamsg.pno }
        );
        if (!data) return;
        this.tabledata = data.data;
        this.$nextTick((_) => {
          this.$print(this.$refs.tablelist);
        });
      }, 300);
    },
    handleCurrentChange(index) {
      if (this.tablelist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.gettablelist();
    },
    //导出
    printList() {
      printExcel.call(
        this,
        '/api/replenish/log/exportPileDatail',
        '充电桩列表',
        this.selectitem
      );
    },
    //返回
    goback(){
      this.$router.go(-1)
    }
  },
};
</script>
<style lang="scss" scoped>
.cargolist {
  position: relative;
  height: 100%;
  .select_box1 {
    display: inline-block;
    font-size: 80%;
    font-weight: 400;
    height: 30px;
    vertical-align: middle;
    margin-left: 10px;
    background-color: #f3f4f5;
  }
  .southcargonn {
    width: 100%;
    height: calc(100% - 50px);
    .bigbox {
      // position: relative;
      box-sizing: border-box;
      height: 100%;
      .southcargo_top {
        // position: relative;
        box-sizing: border-box;
        border-radius: 2px;
        background: #ffffff;
        padding: 10px;
        overflow: auto;
        margin: 10px;
        border-radius: 20px;
        .steer {
          margin-left: 31px;
          margin-top: 5px;
        }
        .southcargo_top_content {
          // position: absolute;
          
          font-size: 80%;
          right: 10px;
          display: flex;
          justify-content: space-around;
          ul {
            line-height: 45px;
          }
          li {
            padding: 0;
            margin: 0;
            list-style: none;
          }
        }
      }
      .southcargo_bot {
        // position: absolute;
        box-sizing: border-box;
        margin: 10px;
        padding: 10px;
        border-radius: 20px;
        // width: 98%;
        height: calc(100% - 180px);
        overflow: auto;
        background: #ffffff;
        .list_title {
          // position: relative;
          padding-left: 10px;
          height: 45px;
          line-height: 55px;
          font-size: 100%;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title-left{
            input {
            padding-left: 10px;
            width: 160px;
            height: 30px;
            outline: none;
            border: none;
            background: #f3f4f5;
            border-radius: 2px;
          }
          }
          .title-right{
              button {
              width: 80px;
              height: 30px;
              background: #17b6a1;
              border-radius: 8px;
              border: none;
              color: #fff;
              margin-left: 20px;
              font-size: 80%;
            }
            .button1 {
              width: 80px;
              height: 30px;
              background: #f5f6fa;
              border-radius: 8px;
              border: none;
              color: #17b6a1;
              margin-left: 20px;
            }
          }
         
        }
        .southcargo_bot_title {
          // position: relative;
          box-sizing: border-box;
          height: 45px;
          font-size: 80%;
        }
        .tablebox {
          // position: absolute;
          // top: 80px;
          // bottom: 0;
          width: 100%;
          height: calc(100% - 50px);
          margin-top: 5px;
          // overflow: hidden;
          .paging {
            // position: absolute;
            width: 100%;
            bottom: 0;
            height: 30px;
            text-align: center;
          }
        }
      }
    }
  }
  .tableprint {
    display: none;
  }
}
</style>
